export default "__VITE_ASSET__f66808d3__"